import {Injectable} from "@angular/core";
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class EditService{
  constructor(private httpClient: HttpClient) {
  }

  ChangePassword(apikey: string, data: any)
  {
    return this.httpClient.post('https://api2.sitederecrutement.com/Home/updatecandidate?apikey='+apikey, data, { responseType: "text" }).subscribe();
  }
}
